import { CreateBadgeRequest, DeleteBadgeRequest, UpdateBadgeRequest } from './badge.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/badges`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateBadgeRequest = (data: CreateBadgeRequest): [string, HttpPostOptions<CreateBadgeRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getViewBadgesRequest = (): [string, HttpGetOptions] => [getEndpoint(), getHttpGetOptions()];

export const getUpdateBadgeRequest = (data: UpdateBadgeRequest): [string, HttpPutOptions<UpdateBadgeRequest>] => [
  getEndpoint(),
  getHttpPutOptions(data)
];

export const getDeleteBadgeRequest = (data: DeleteBadgeRequest): [string, HttpDeleteOptions] => [
  getSpecificEndpoint(data.badgeExternalReference),
  getHttpDeleteOptions()
];
